import { isSemTraffic } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromSEM";
import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useSearchParams } from "next/navigation";
import { useMemo } from "react";
/**
 * @name useIsSemDiscoverPage
 * @description Determines if user is a paid user
 * and if the current page is the logged out discover page.
 *
 * @note medium=cpc is the query parameter that is
 * used to determine if the user is a paid user.
 * We also need to determine if the user is on the discover page.
 */ export var useIsSemDiscoverPage = function() {
    var isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
    var searchParams = useSearchParams();
    var _searchParams_entries;
    var searchParamsObject = Object.fromEntries((_searchParams_entries = searchParams === null || searchParams === void 0 ? void 0 : searchParams.entries()) !== null && _searchParams_entries !== void 0 ? _searchParams_entries : []);
    return useMemo(function() {
        return isSemTraffic(searchParamsObject) && isLoggedOutDiscoverPage;
    }, [
        isLoggedOutDiscoverPage,
        searchParamsObject
    ]);
};
